export default "__VITE_ASSET__441fcc5d__"